<template>
  <div class="App">
    <div class="vertical-center">
      <div class="inner-block">
        <router-view />
      </div>
    </div>
  </div>
</template>
